var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBookSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M5.1 1C3.95 1 3 1.96 3 3.13v12.75C3 17.04 3.95 18 5.1 18H17V1zm0 1.42h10.5v11.33H5.1q-.37 0-.7.13V3.13c0-.4.3-.71.7-.71m1.4 2.12v1.42h7.7V4.54zM5.1 15.17h10.5v1.41H5.1a.7.7 0 0 1-.7-.7c0-.4.3-.71.7-.71"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBookSolid);
export default ForwardRef;